var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseCompletePage',{attrs:{"content":_vm.getTenantsLiabilityCover,"hideSdnExternal":true,"showAllQuoteSummary":false,"cardTitle":_vm.$vuetify.breakpoint.lgAndUp
      ? 'Your Tenant’s Liability Insurance quote - ' + _vm.getMonthCoverText
      : 'Your quote',"insurancePremiumTitle":"Tenants Liability premium (ex IPT)","annualTitle":"One off payment"}})
}
var staticRenderFns = []

export { render, staticRenderFns }